import React from 'react';
import { KeepScale } from 'react-zoom-pan-pinch';

const getMarkerFilterPrice = (markerDetails) =>
  Number(markerDetails.offers_over_price || markerDetails.price || 0);

export default function Marker({
  activeFilters,
  adjustX,
  adjustY,
  marker,
  multiplier,
  setActivePlot,
  setCardOpen,
  type = '',
}) {
  // Very repetitive logic to calculate whether or not the marker should show
  let isEnabled = true;

  // Check each filter category against the data for the marker
  if (activeFilters?.bedrooms?.length > 0) {
    // If the bedrooms array doesn't contain the same value as the bedrooms this marker has in it's data, then set isEnabled to false
    isEnabled = !!activeFilters.bedrooms.filter(
      (activeFilter) => activeFilter === marker.bedrooms
    )?.length;
  }

  if (activeFilters?.status?.length > 0) {
    isEnabled = !!activeFilters.status.filter(
      (activeFilter) => activeFilter === marker.status
    )?.length;
  }

  if (activeFilters?.type?.length > 0 && marker?.house_style?.value) {
    isEnabled = !!activeFilters.type.filter(
      (activeFilter) => activeFilter === marker.house_style.value
    )?.length;
  }

  if (activeFilters?.price?.length > 0) {
    const largestPrice = Math.max(...activeFilters.price);

    if (getMarkerFilterPrice(marker) > largestPrice) {
      isEnabled = false;
    }
  }

  if (activeFilters?.ready_to_move_into) {
    if (!marker.ready_to_move_into) {
      isEnabled = false;
    }
  }

  // If isEnabled is not true by this point. return an empty fragment
  if (!isEnabled) {
    return <></>;
  }

  return (
    <button
      className="siteplan__marker"
      style={{
        left: `${multiplier ? marker.x * multiplier : marker.x * adjustX}px`,
        top: `${multiplier ? marker.y * multiplier : marker.y * adjustY}px`,
      }}
      onClick={() => {
        setActivePlot(marker);
        setCardOpen(true);
      }}
      type="button"
    >
      <KeepScale>
        <span
          className={`siteplan__plot siteplan__plot--${
            type || marker.type
          } siteplan__plot--${marker.status}`}
        >
          <span className="siteplan__label">{marker.label}</span>
        </span>
      </KeepScale>
    </button>
  );
}
